import DateHolidays from "date-holidays";

/**
 * Provides a singleton list of US Federal Holidays in UTC
 * @see https://www.federalreserve.gov/aboutthefed/k8.htm
 */
export const US_FEDERAL_HOLIDAYS = new DateHolidays("US", {
  timezone: "UTC",
  types: ["bank", "public"],
});
